import { render } from "./TagsView.vue?vue&type=template&id=1975cd20&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=ts"
export * from "./TagsView.vue?vue&type=script&lang=ts"

import "./TagsView.vue?vue&type=style&index=0&id=1975cd20&lang=scss&scoped=true"
import "./TagsView.vue?vue&type=style&index=1&id=1975cd20&lang=scss"
script.render = render
script.__scopeId = "data-v-1975cd20"

export default script